import { Game } from '@Game/Game';
import { GameStore } from '@GameStore/GameStore';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { EGameStates } from '@Managers/StateManager/GameStates';

export class RestoreManager {
    private readonly gameStore: GameStore;

    constructor(game: Game) {
        this.gameStore = game.gameStore;
        EventsCenter.on(EGameEvents.PRELOADER_INFO_CONTINUE, this.onInit, this);
        EventsCenter.on(EGameStates.GAME_START, this.onGameStart, this);
        EventsCenter.once(EGameStates.SPIN_STATE, this.onSpinStart, this);
    }

    private onInit(): void {
        const shouldRestore = [this.restoreLockAndRoll(), this.restoreFreeGames()].some(Boolean);
        if (shouldRestore) this.gameStore.set(EGameStoreKeys.IsGameRestored, true);
    }

    private onGameStart(): void {
        const shouldRestore = this.gameStore.get(EGameStoreKeys.IsGameRestored);
        if (shouldRestore) EventsCenter.emit(EGameEvents.SPECIAL_GAMES_RESTORE);
    }

    private onSpinStart(): void {
        this.gameStore.set(EGameStoreKeys.IsGameRestored, false);
        this.gameStore.set(EGameStoreKeys.ResumedSpinOutcome, undefined);
    }

    private restoreLockAndRoll(): boolean {
        const lockAndRollData = this.gameStore.get(EGameStoreKeys.LockAndRoll);
        if (lockAndRollData.totalSpins <= 0) return false;
        return true;
    }

    private restoreFreeGames(): boolean {
        const freeGamesData = this.gameStore.get(EGameStoreKeys.FreeGames);
        if (freeGamesData.totalSpins <= 0) return false;
        return true;
    }
}
